import {gql} from '@apollo/client';

export const PAGINATE_LIVES = gql`
    query PaginateLives(
        $first: Int!
        $page: Int!
        $search: String
        $filters: String
    ) {
        paginateLives(
            first: $first
            page: $page
            search: $search
            filters: $filters
        ) {
            paginatorInfo {
                count
                currentPage
                firstItem
                perPage
                lastItem
                total
            }
            data {
                id
                name
                document
                birthdate
                phone
                cpf
                status
                risk
                next_event {
					id
					code
					name
					begin_at
					finished_at
				}
                created_at
            }
        }
    }
`;

export const PAGINATE_HIGH_RISK_LIVES = gql`
    query PaginateHighRiskLives(
        $first: Int!
        $page: Int!
        $search: String
        $filters: String
    ) {
        paginateHighRiskLives(
            first: $first
            page: $page
            search: $search
            filters: $filters
        ) {
            paginatorInfo {
                count
                currentPage
                firstItem
                perPage
                lastItem
                total
            }
            data {
                id
                name
                document
                birthdate
                phone
                cpf
                status
                risk
                next_event {
					id
					code
					name
					begin_at
					finished_at
				}
                created_at
            }
        }
    }
`;

export const GET_LIFE = gql`
    query GetLife(
        $id: String!
    ) {
        getLife(
            id: $id
        ) {
            id
            name
            document
            birthdate
            phone
            integration_identifiers
            created_at
            deleted_at
            assessments {
                id
                code
                event {
                    id
                    code
                    name
                    begin_at
                    finished_at
                }
                evaluations {
                    key
                    tag
                    value
                    data
                    order
                }
                metrics {
                    name
                    tag
                    value
                    result
                    results
                }
                answered_at
            }
            programs {
                id
                name
            }
            next_event {
                id
                code
                name
                begin_at
                finished_at
            }
        }
    }
`;